import { createContext } from 'react'

export const ScreenContainerRef = createContext(null)
